import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DataFormatService } from '../../../services/data-format.service';
import moment from 'moment';
import Disposition from 'src/app/interfaces/disposition';

export type DispositionInfoTable = {
  related_party: string | null;
  purchaser: { name?: string | null; __typename?: string } | null;
  disposition_type: string | null;
  disposition_status: string | null;
  monitoring_compliance: string | null;
  disposition_committee: string | null;
  closing_date: string | null;
  board_consent_sent: string | null;
  board_consent_received: string | null;
  investor_consent_sent: string | null;
  investor_consent_received: string | null;
};

@Component({
    selector: 'deal-dispositions-section',
    templateUrl: './dispositions.component.html',
    styleUrls: ['./dispositions.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DispositionsComponent implements OnInit {
  @Input() dispositions: Disposition[];
  @Input() projectDetails: any;
  @Input() permissions: any;

  dispositionData: DispositionInfoTable[];
  dispositionInfoColumns: string[] = [
    'purchaser',
    'related_party',
    'disposition_type',
    'disposition_status',
    'monitoring_compliance',
    'disposition_committee',
    'closing_date',
    'board_consent_sent',
    'board_consent_received',
    'investor_consent_sent',
    'investor_consent_received',
  ];

  constructor(private dataFormat: DataFormatService) {}

  ngOnInit() {
    this.dispositionData = this.formatDispositions();
  }
  findDate(disposition: Disposition, name: string): string | null {
    let date = null;
    if (disposition.dispositionDates) {
      let dispositionDate = disposition.dispositionDates.find(
        (dispositionDate) =>
          (dispositionDate.dateType?.name?.indexOf(name) ?? -1) > -1
      );
      if (dispositionDate) {
        date = moment(dispositionDate.date).format('MM/DD/YYYY');
      }
    }
    return date;
  }
  formatDispositions() {
    let formatted: DispositionInfoTable[] = [];
    if (this.dispositions) {
      for (let disposition of this.dispositions) {
        let tableInfo: DispositionInfoTable = {
          related_party: null,
          purchaser: null,
          disposition_type: null,
          disposition_status: null,
          monitoring_compliance: null,
          disposition_committee: null,
          closing_date: null,
          board_consent_sent: null,
          board_consent_received: null,
          investor_consent_sent: null,
          investor_consent_received: null,
        };
        tableInfo.purchaser = disposition.organization ?? {
          name: disposition.purchaser,
        };
        tableInfo.related_party =
          disposition.related_party === null
            ? null
            : disposition.related_party
            ? 'Yes'
            : 'No';
        tableInfo.disposition_type = disposition.dispositionType?.name ?? null;
        tableInfo.disposition_status =
          disposition.dispositionStatuses?.find(
            (dispositionStatus: any) =>
              dispositionStatus.statusSequence?.name === 'Disposition'
          )?.status?.name ?? null;
        tableInfo.monitoring_compliance =
          disposition.monitoring_compliance === null
            ? null
            : disposition.monitoring_compliance
            ? 'Yes'
            : 'No';
        let committeeDate = disposition.dispositionPipelineDates?.find(
          (dispositionPipelineDate: any) =>
            dispositionPipelineDate.pipelineMilestone?.milestone?.name ===
            'Disposition Committee'
        )?.date;
        tableInfo.disposition_committee = committeeDate
          ? moment(committeeDate).format('MM/DD/YYYY')
          : null;
        let closingDate = disposition.dispositionPipelineDates?.find(
          (dispositionPipelineDate: any) =>
            dispositionPipelineDate.pipelineMilestone?.milestone?.name ===
            'Closed'
        )?.date;
        tableInfo.closing_date = closingDate
          ? moment(closingDate).format('MM/DD/YYYY')
          : null;
        if (disposition.board_consent_na) {
          tableInfo.board_consent_sent = 'N/A';
          tableInfo.board_consent_received = 'N/A';
        } else {
          tableInfo.board_consent_sent = this.findDate(
            disposition,
            'Board Consent Sent'
          );
          tableInfo.board_consent_received = this.findDate(
            disposition,
            'Board Consent Received'
          );
        }
        if (disposition.investor_consent_na) {
          tableInfo.investor_consent_sent = 'N/A';
          tableInfo.investor_consent_received = 'N/A';
        } else {
          tableInfo.investor_consent_sent = this.findDate(
            disposition,
            'Investor Consent Sent'
          );
          tableInfo.investor_consent_received = this.findDate(
            disposition,
            'Investor Consent Received'
          );
        }
        formatted.push(tableInfo);
      }
    }
    return formatted;
  }
}
